import React from "react";
import { AlertTriangle, RefreshCw, Home, ChevronRight } from "lucide-react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
    this.setState({ errorInfo });

    // Detect ChunkLoadError (happens when new deployment replaces older chunk bundles)
    if (
      error?.name === "ChunkLoadError" ||
      error?.message?.includes("Loading chunk") ||
      error?.message?.includes("failed to fetch dynamically imported module")
    ) {
      console.warn("ChunkLoadError detected, attempting automatic reload in 1.5s...");
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    }
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    window.location.href = "/";
  };

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      const errorMsg = this.state.error?.message || "Terjadi kesalahan tidak terduga pada halaman ini.";
      const isChunkError =
        this.state.error?.name === "ChunkLoadError" ||
        this.state.error?.message?.includes("Loading chunk") ||
        this.state.error?.message?.includes("failed to fetch dynamically imported module");

      return (
        <div className="min-h-[70vh] w-full flex flex-col items-center justify-center p-6 text-center animate-in fade-in duration-300">
          <div className="max-w-md w-full p-6 sm:p-8 rounded-3xl border border-rose-500/30 bg-[#07080f]/95 backdrop-blur-2xl shadow-2xl shadow-rose-500/10 space-y-5">
            <div className="w-16 h-16 rounded-2xl bg-rose-500/10 border border-rose-500/30 flex items-center justify-center mx-auto text-rose-400 shadow-lg shadow-rose-500/10">
              <AlertTriangle size={32} />
            </div>

            <div className="space-y-2">
              <h2 className="font-display font-bold text-xl text-white tracking-tight">
                {isChunkError ? "Pembaruan Sistem Terdeteksi" : "Gagal Memuat Komponen"}
              </h2>
              <p className="text-xs text-white/60 leading-relaxed">
                {isChunkError
                  ? "Sistem sedang memuat berkas versi terbaru. Halaman akan dimuat ulang secara otomatis."
                  : "Terjadi galat pada antarmuka admin. Anda dapat memuat ulang atau kembali ke dashboard."}
              </p>
            </div>

            <div className="p-3.5 rounded-xl bg-black/60 border border-white/5 text-left font-mono-tech text-[11px] text-rose-300 overflow-x-auto max-h-28">
              {errorMsg}
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-2.5 pt-2">
              <button
                onClick={this.handleReload}
                className="w-full sm:flex-1 py-2.5 px-4 rounded-xl bg-primary text-white font-bold text-xs hover:bg-primary/90 transition-all flex items-center justify-center gap-2 shadow-lg shadow-primary/25 cursor-pointer"
              >
                <RefreshCw size={14} />
                <span>Muat Ulang Halaman</span>
              </button>

              <button
                onClick={this.handleReset}
                className="w-full sm:flex-1 py-2.5 px-4 rounded-xl bg-white/5 border border-white/10 text-white/80 hover:bg-white/10 hover:text-white font-semibold text-xs transition-all flex items-center justify-center gap-1.5 cursor-pointer"
              >
                <Home size={14} />
                <span>Ke Dashboard</span>
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
